import { createTheme } from '@mui/material/styles'
import { grey } from '@mui/material/colors'
const theme = createTheme()
const levelOnePadding = `calc(${theme.spacing(6)} - 0.25rem) !important`
const levelTwoPadding = `calc(${theme.spacing(8)} - 0.25rem) !important`
const inlinePadding = `${theme.spacing(1)} !important`
const logoHeight = theme.spacing(7)

export const collapsedWidth = `calc(${theme.spacing(9)} + 0.25rem)`
export const normalWidth = '16.25rem'

const commonInlinePadding = {
  paddingTop: inlinePadding,
  paddingBottom: inlinePadding,
}

export const customStyles = {
  listItemButton: {
    paddingLeft: levelOnePadding,
    commonInlinePadding,
  },
  levelTwoDropdown: {
    commonInlinePadding,
    paddingLeft: levelTwoPadding,
  },
  logoStyles: {
    width: '100%',
    height: logoHeight,
  },
  headerWrapper: {
    height: '8rem',
    zIndex: 1,
    top: 0,
    backgroundColor: grey[50],
  },
  hamburgerButton: {
    margin: '0.25rem 0.25rem 0rem 1.25rem',
  },
  logoWrapper: {
    padding: '0.75rem',
  },
}
